import { notification } from 'antd';
import { CloseCircleOutlined, CheckCircleOutlined, InfoCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

let NotificationServiceInstance;

export default class NotificationService {
    constructor() {
        if (!NotificationServiceInstance) {
            NotificationServiceInstance = this;
        }
        return NotificationServiceInstance;
    }

    error(title, message) {
        notification.open({
            message: title ?? 'Error',
            description: message ?? 'Server error',
            icon: <CloseCircleOutlined style={{ color: 'red' }} />,
            duration: 4,
        });
    }

    success(title, message) {
        notification.open({
            message: title ?? 'Success',
            description: message ?? '',
            icon: <CheckCircleOutlined style={{ color: 'green' }} />,
            duration: 3,
        });
    }

    info(title, message) {
        notification.open({
            message: title ?? 'Info',
            description: message ?? '',
            icon: <InfoCircleOutlined style={{ color: '#1890ff' }} />,
            duration: 3,
        });
    }

    warning(title, message) {
        notification.open({
            message: title ?? 'Warning',
            description: message ?? '',
            icon: <ExclamationCircleOutlined style={{ color: 'orange' }} />,
            duration: 4,
        });
    }
}
